export default __webpack_public_path__ + "361623eeabc36119411b54f8b940bf53.svg";